import OpusLayer from "lib/classes/opuslayer";

interface LayerGroupProps {
	id:number,
	name:string,
	colour:string,
	isHidden:boolean,
	layers:OpusLayer[],
	legendOrder:number,
	collapsed:boolean,
	json:string
}

/**
	* OpusMaps map layer group class
	* 
	* @remarks
	* Used mainly in views/MapLayerTool
	* 
	* @param id				-	ID of the layer group
	* @param name			-	Name of the layer group
	* @param colour			-	Colour of the layer group
	* @param isHidden		-	Visibility of the layer group
	* @param layers			-	Associated OpusLayer map layers
	* @param legendOrder	-	Order of the group on the legend
*/
export default class OpusLayerGroup implements LayerGroupProps {
	public id:number;
	public name:string;
	public colour:string;
	public isHidden:boolean;
	public layers:OpusLayer[];
	public legendOrder:number;
	public collapsed:boolean;
	public json:string;
	
	private visible:boolean = false;
	private allVisible:boolean = false;
	private customObj:any;
	
	public get shouldShowOnMap():boolean {
		return this.isHidden !== true;
	}
	public get shouldShowInLegend():boolean {
		return this.customObj?.hiddenInLegend !== true;
	}
	
	constructor({id, name, colour, isHidden, layers, legendOrder, collapsed, json}:LayerGroupProps) {
		this.id = id;
		this.name = name;
		this.colour = colour;
		this.isHidden = isHidden;
		this.layers = layers;
		this.legendOrder = legendOrder;
		this.visible = isHidden;
		this.collapsed = collapsed;
		this.json = json;
		
		try {
			if(typeof this.json === 'string' && this.json)
				this.customObj = JSON.parse(this.json);
		}catch(e:any) { console.error('Error parsing custom layer group json', e); }
	}
	public setVisible(visible:boolean) {
		this.layers.forEach((opusLayer:OpusLayer) => {
			if(opusLayer._visibleInLegendOMV)
				opusLayer.setVisible(visible);
		});
		this.visible = visible;
	}
	public getVisible():boolean {
		return this.visible;
	}
	public getAllVisible():boolean {
		return this.allVisible;
	}
	public updateAllVisible() {
		let allVisible:boolean = true;
		
		for(let l of this.layers) {
			if(l._visibleInLegendOMV && !l.getVisible()) {
				allVisible = false;
				break;
			}
		}
		
		this.allVisible = allVisible;
	}
}